import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import BarChartIcon from '@mui/icons-material/BarChart';
import StarIcon from '@mui/icons-material/Star';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { useNavigate } from 'react-router-dom';
import { useAppTrialAccess } from '../useAppTrialAccess';
import ActivarSuscripcionBanner from '../ActivarSuscripcionBanner';
import '../premiumLanding.css';

export default function FastFoodLandingPage() {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    canRequestTrial,
    mustRenew,
    startTrial,
  } = useAppTrialAccess('fastfood_pos_v1');

  return (
    <div className="pl">
      {/* HERO */}
      <section className="pl-hero">
        <div className="pl-wrap">
          <span className="pl-eyebrow">POS para comida rápida</span>
          <h1>POS Comida Rápida</h1>
          <p className="pl-hero-sub">
            Controla tus ventas, cobra más rápido y descubre qué platos se venden más.{' '}
            <strong>Hecho para pequeños negocios de comida rápida.</strong>
          </p>
          <div className="pl-cta-row">
            {canRequestTrial && (
              <button type="button" className="pl-btn pl-btn-accent" onClick={startTrial}>
                Probar ahora
              </button>
            )}
            {!isAuthenticated && (
              <button type="button" className="pl-btn pl-btn-accent" onClick={() => navigate('/login')}>
                Inicia sesión para probar gratis
              </button>
            )}
          </div>
          {mustRenew && (
            <div style={{ marginTop: 32, textAlign: 'left' }}>
              <ActivarSuscripcionBanner appKey="fastfood_pos_v1" appName="POS Comida Rápida" />
            </div>
          )}
          <p className="pl-hero-note">Desde USD 2 / mes · Sin contratos · Cancela cuando quieras</p>
        </div>
      </section>

      {/* PARA QUIÉN ES */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>¿Para quién es este sistema?</h2>
            <p>Diseñado para negocios pequeños que quieren ordenarse, cobrar mejor y dejar el cuaderno.</p>
          </div>
          <div className="pl-usecase-grid">
            {[
              'Pollo broaster',
              'Hamburguesas',
              'Salchipapas y hot dogs',
              'Venta de bebidas y combos',
              'Restaurantes familiares',
              'Puestos y locales pequeños',
            ].map((item) => (
              <div key={item} className="pl-usecase">{item}</div>
            ))}
          </div>
        </div>
      </section>

      {/* PROBLEMAS */}
      <section className="pl-section pl-section-muted">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>Problemas que seguramente te pasan</h2>
          </div>
          <div className="pl-ps-col" style={{ maxWidth: 720, margin: '0 auto' }}>
            <ul>
              {[
                'No sabes cuánto vendiste ayer',
                'No sabes cuál es tu plato más vendido',
                'Las cuentas no cuadran al final del día',
                'Pierdes tiempo sumando ventas',
                'No das ticket al cliente',
                'No sabes si estás ganando o solo trabajando',
              ].map((p) => (
                <li key={p}>
                  <b>✗</b>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* SOLUCIÓN */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>La solución: POS Comida Rápida Devssoft</h2>
          </div>
          <div className="pl-feature-grid">
            {[
              {
                icon: <PointOfSaleIcon />,
                title: 'Punto de Venta rápido',
                text: 'Cobra en segundos, agrega productos fácilmente y maneja cantidades sin errores.',
              },
              {
                icon: <ReceiptLongIcon />,
                title: 'Tickets automáticos',
                text: 'Imprime tickets y dale una imagen más profesional a tu negocio.',
              },
              {
                icon: <BarChartIcon />,
                title: 'Control de ventas',
                text: 'Mira ventas por día, mes y rango de fechas.',
              },
              {
                icon: <StarIcon />,
                title: 'Platos más vendidos',
                text: 'Descubre qué productos funcionan mejor.',
              },
              {
                icon: <PhoneAndroidIcon />,
                title: 'Funciona en cualquier dispositivo',
                text: 'Celular, tablet o computadora. Sin equipos caros.',
              },
            ].map(({ icon, title, text }) => (
              <div key={title} className="pl-feature-card">
                <div className="pl-feature-icon">{icon}</div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRECIO */}
      <section className="pl-final">
        <div className="pl-wrap">
          <h2>Precio simple y accesible</h2>
          <p className="pl-price">USD 2 / mes</p>
          <p>Sin contratos · Sin costos ocultos · Cancela cuando quieras</p>
          <div className="pl-cta-row">
            <button
              type="button"
              className="pl-btn pl-btn-accent"
              onClick={canRequestTrial ? startTrial : !isAuthenticated ? () => navigate('/login') : undefined}
              disabled={mustRenew}
            >
              {!isAuthenticated ? 'Inicia sesión para empezar' : 'Empezar ahora'}
            </button>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-cta-block">
            <h2>Tu negocio merece dejar el cuaderno</h2>
            <p>Empieza simple, cobra mejor y toma decisiones con datos reales.</p>
            <div className="pl-cta-row">
              <button
                type="button"
                className="pl-btn pl-btn-primary"
                onClick={canRequestTrial ? startTrial : !isAuthenticated ? () => navigate('/login') : undefined}
                disabled={mustRenew}
              >
                {!isAuthenticated ? 'Inicia sesión para probar' : 'Probar POS Comida Rápida'}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
